import React from 'react';

var FavouritesFilled = function FavouritesFilled(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 6.204l.759-.755a5.505 5.505 0 0 1 7.625.176 5.576 5.576 0 0 1-.003 7.855l-6.842 6.88a2.17 2.17 0 0 1-3.08 0l-6.841-6.88a5.579 5.579 0 0 1-.003-7.855 5.502 5.502 0 0 1 7.625-.176l.76.755z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

FavouritesFilled.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { FavouritesFilled as icon };
export default iconHandler(FavouritesFilled);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/FavouritesFilled.js
// module id = 599
// module chunks = 0